import { createAction } from '@reduxjs/toolkit';

export const welcomeCompleted = createAction('welcome completed');
